import React from "react";
import styled, { css } from "styled-components";

interface STableHead {
  isFixedHeader?: boolean;
}

interface STableBodyItem {
  clickable?: boolean;
  isKeepAll?: boolean;
  isNeedUnderline?: boolean;
  isNeedLineThrough?: boolean;
}

interface STableContainer extends STableHead {
  tableMinWidth?: number;
}

interface TableProps extends STableContainer {
  tableHeadData?: (string | undefined | JSX.Element)[];
  children: JSX.Element | JSX.Element[];
  customTableHeader?: JSX.Element;
  [key: string]: any;
}

export default function Table({
  tableHeadData,
  children,
  tableMinWidth,
  isFixedHeader,
  isNeedLineThrough,
  customTableHeader,
  ...rest
}: TableProps) {
  return (
    <TableContainer
      tableMinWidth={tableMinWidth}
      isFixedHeader={isFixedHeader}
      {...rest}
    >
      {customTableHeader ?? (
        <TableHead isFixedHeader={isFixedHeader}>
          <TableHeadContainer>
            {tableHeadData?.map((t, index) => {
              return (
                <>
                  {t && (
                    <TableHeadItem key={index} isFixedHeader={isFixedHeader}>
                      {t}
                    </TableHeadItem>
                  )}
                </>
              );
            })}
          </TableHeadContainer>
        </TableHead>
      )}

      <tbody>{children}</tbody>
    </TableContainer>
  );
}

const TableContainer = styled.table<STableContainer>`
  position: relative;
  width: 100%;
  min-width: ${({ tableMinWidth }) => tableMinWidth ?? 673}px;

  ${({ isFixedHeader }) =>
    isFixedHeader
      ? css`
          border-collapse: separate;
          border-spacing: 0;
        `
      : css``}
`;

export const TableHead = styled.thead<STableHead>`
  width: 100%;
  border-bottom: 2px solid #d4d9e1;

  ${({ isFixedHeader }) =>
    isFixedHeader
      ? css`
          background-color: white;
          height: 68px;
        `
      : css`
          height: 40px;
        `}
`;

export const TableHeadContainer = styled.tr`
  border-bottom: 2px solid #d4d9e1;
`;

export const TableHeadItem = styled.th<STableHead>`
  padding: 11px 10px;
  word-break: keep-all;

  font-size: 15px;
  font-weight: bold;
  line-height: 22.5px;
  text-align: left;
  color: #858c97;

  ${({ isFixedHeader }) =>
    isFixedHeader
      ? css`
          position: sticky;
          top: 0;
          vertical-align: bottom;
          border-bottom: 2px solid #d4d9e1;
          background-color: white;
        `
      : css``}
`;

export const TableBody = styled.tr`
  border-bottom: 1px solid #d4d9e1;
`;

export const TableBodyItem = styled.td<STableBodyItem>`
  cursor: ${({ clickable }) => (clickable ? "pointer" : "auto")};
  text-decoration: ${({ clickable, isNeedLineThrough }) =>
    isNeedLineThrough ? "line-through" : clickable ? "underline" : "none"};
  padding: 21px 10px;
  font-size: 15px;
  font-weight: 500;
  line-height: 22.5px;
  text-align: left;
  color: #2f2f38;
  height: 100%;
  vertical-align: middle;
  word-break: ${({ isKeepAll }) => (isKeepAll ? "keep-all" : "normal")};
  border-bottom: ${({ isNeedUnderline }) =>
    isNeedUnderline ? `1px solid #d4d9e1` : `none`};
`;
